/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EPresciptionINFOPRESCRIPTIONPRESCRIPTIONCONTENUPRESCRIPTIONLIGDISPOSITIFMEDICALInner { 
    CodeACL?: string;
    CodeLPP?: string;
    CodeREF13?: string;
    CodeUDI?: string;
    DureeLocationLPP?: number;
    EstEnRapportALD?: boolean;
    EstEnRapportAccident?: boolean;
    EstEnRapportPrev?: boolean;
    EstNonRemb?: boolean;
    LibelleLPPLibre?: string;
    LibelleMarque?: string;
    NbConditionnement?: number;
    NbRenouv?: number;
    NumLigne?: number;
}

